import React from 'react'
import '../Css/Header.css'

const Header = () => {
    return (
        <div id="containerHeader">
            <div id="containerColorHeader">
                <h2 id="nameHeader">VALERIA</h2>
                <h3 id="lastNameHeader">BRITO</h3>
                <h3 id="pointPresentationHeader">.</h3>
            </div>
        </div>
    )
}

export default Header
